import { TextField } from "@mui/material";
import { FC } from "react";
import { useShallow } from "zustand/shallow";
import { useCollectionDialogStore } from "./stores/CollectionDialogStore";

export const DescriptionInput: FC = () => {
  const { description, setDescription } = useCollectionDialogStore(
    useShallow((state) => ({
      description: state.description,
      setDescription: state.setDescription,
    }))
  );

  return (
    <TextField
      label="Description"
      placeholder=""
      value={description}
      onChange={(e) => setDescription(e.target.value)}
      inputProps={{ "data-testid": "collections-description-input" }}
      fullWidth
      variant="outlined"
      multiline
      rows={4}
    />
  );
};
